import PropTypes from "prop-types";
import React from "react";

const HomeAlertCardJobPromo = ({ subscriptionsURL }) => (
    <div className="slider-card slider-card--home cand-home__ref-card">
        <div className="cand-home__job-alerts-card cand-home__ref-card-header" />
        <p>Want to be the first to know?</p>
        <span>
            Enable job alerts to get notified as soon as new good-fit roles open up in your area
        </span>
        <div className="cand-home__ref-options">
            <a
                href={`${subscriptionsURL}&coms_group=job_opportunities:1&utm_source=cand-home&utm_medium=web&utm_campaign=card`}
            >
                Enable job alerts
            </a>
        </div>
    </div>
);

HomeAlertCardJobPromo.propTypes = {
    subscriptionsURL: PropTypes.string.isRequired,
};

export default HomeAlertCardJobPromo;
